<template>
	<div :v-model="messagekVisible" id="MissionCenter">
		<div class="searchNav">
			<el-form :inline="true" :model="formInline" ref="ruleForm" class="demo-form-inline">
				<el-form-item label="创建时间：" style="width:380px">
					
					<el-date-picker type="date" size="mini" placeholder="选择日期" value-format="yyyy-MM-dd"  v-model="formInline.beginDate" style="width:130px"></el-date-picker>
                    <span> - </span>
					<el-date-picker type="date" size="mini"  placeholder="选择日期" value-format="yyyy-MM-ddTHH:mm:ss.000+0800" default-time="23:59:59" v-model="formInline.endDate" style="width:130px"></el-date-picker>
					
				</el-form-item>
				<el-form-item label="类型："  style="width:180px">
					<el-select v-model="formInline.type" size="mini" style="width:120px">
						<el-option label="全部" value="null"></el-option>
						<el-option label="导出" value="export"></el-option>
						<el-option label="导入" value="upload"></el-option>
						<el-option label="其它" value="service"></el-option>
					</el-select>
				</el-form-item>
			    <el-form-item label="模块"  style="width:200px">
					<el-select v-model="formInline.module" size="mini" style="width:120px" >
						<el-option label="全部" value="null"></el-option>
						<el-option label="商品模块" value="商品模块"></el-option>
						<el-option label="客服模块" value="客服模块"></el-option>
					</el-select>
				</el-form-item>	
				<el-form-item>
					<el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
					<el-button size="mini" @click="resetForm('ruleForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<CAVPaginationV2 :total="total" :page-size="formInline.pageSize" :currentPage="formInline.pageNo" :page-sizes="[20,30, 50, 100, 200]" @size-change="handleSizeChange" @current-change="handleCurrentChange" style="margin-right:10px;float:right"></CAVPaginationV2>
			
		</div>
		<div style="height: calc(100vh - 160px);">
		    <vxe-table :loading="loading" :data="newTaskData" resizable auto-resize  border size="mini" stripe height="100%"  highlight-current-column>
				<vxe-table-column type="seq" align="center"  width="60"></vxe-table-column>
				<vxe-table-column field="createTime" title="创建时间" width="160">
					<template v-slot="{row}">
						<span>{{ row.createTime | dataFilter }}</span>
					</template>
				</vxe-table-column>
				<vxe-table-column field="name" title="任务名称" width="260">
					<template v-slot="{row}">
						<span>{{ row.name}}</span>
						<span style="display: block; color: #959595;">{{row.description}}</span>
					</template>
				</vxe-table-column>
				<vxe-table-column field="type" align="center" title="类型" width="80">
					<template v-slot="{row}">
						<span>{{ row.type | typeFilter}}</span>
					</template>
				</vxe-table-column>
				<vxe-table-column field="module" title="业务模块" width="100"></vxe-table-column>
				<vxe-table-column field="rowNum" align="right" title="记录数" width="100"></vxe-table-column>
				<vxe-table-column field="state" title="状态" >
					<template v-slot="{row}">
						<div>
							<span v-if="row.state === 'complete'" style="color: #008200;">{{ row.state | stateFilter }}</span>
							<span v-else-if="row.state === 'error'" style="color: #d15053;">{{ row.state | stateFilter }}</span>
							<span v-else-if="row.state === 'cancelled'" style="color: #d15053;">{{ row.state | stateFilter }}</span>
							<span v-else style="color: #dcba56;">{{ row.state | stateFilter }}</span>
							<i style="padding:0 5px;color: #e0e0e0;" >|</i>
							<span>{{row.message}}</span>
						</div>
					</template>
				</vxe-table-column>
				<vxe-table-column field="options" title="操作" width="160">
					<template v-slot="{row}">
						<div  v-if="row.state === 'complete'">
							<span  v-if="sizeTimeFilter(row.createTime)"  style="color: #206ca4;cursor: pointer;" @click="downLoadeHandle(row)">下载</span>
							<span v-else style="color: #f1a314;">已过期</span>
							<i style="padding:0 5px;color: #e0e0e0;" >|</i>
							<span>已下载{{ row.downloadTimes }}次</span>
						</div>
						
					</template>
				</vxe-table-column>
			</vxe-table>
		</div>	
	</div>
</template>
<script>
import CAVPaginationV2 from './CAVPaginationV2';
import {taskList } from '@/api/home'
import downloadMixin from './mixin/index';
import moment from 'moment';
export default {
	name: 'MissionCenter',
	components: {CAVPaginationV2},
	mixins: [downloadMixin],
	props: {
		messagekVisible: {  
            type: Boolean,
            default: false,
        },
	},
	data() {
		return {
			loading:false,
			total:100,
			formInline: {
				beginDate: moment().subtract(6, 'days').format('yyyy-MM-DD'),
				endDate:'',
				type:'null',
				module:'null',
				pageSize:20,
				pageNo:1,
			},
			newTaskData:[],
		}
	},
    watch:{},
	methods: {
		handleSizeChange(val){
			this.formInline.pageSize = val
			this.taskDataHandle();

		},
		handleCurrentChange(val){
            this.formInline.pageNo = val
			this.taskDataHandle()
		},
		sizeTimeFilter(val){
            let time1 =  moment().subtract(6, 'days').format('yyyy-MM-DD');
		    let time = moment(val).format('YYYY-MM-DD');
		    // 获取倒推后的年、月、日
		
			if (time > time1) {
				return 1
			} else if (time1 < time) {
				return 0
			} 
		},
		/**
		 * 点击下载
		 */
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		onSubmit() {
			this.taskDataHandle();
		},
		/**
		 * 请求列表数据
		 */
		taskDataHandle(){
			this.loading = true;
			taskList(this.formInline).then(res=>{
				this.newTaskData =res.$data;
				this.total = res.$entityCount;
				this.loading = false;
			})
		},
	},
	mounted() {},
	created() {
		
		this.taskDataHandle()
	},
	filters:{
		dataFilter(val){
			return  moment(val).format('YYYY-MM-DD HH:mm:ss')
		},
		
		stateFilter(val){
			let result=""
			switch (val) {
				case 'complete':
					result = '完成'
					break;
				case 'error':
					result = '失败'
					break;
				case 'cancelled':
					result = '已取消'
					break;
				default:
					result = '进行中'
					break;
			}
			return result
		},
		typeFilter(val){
			let result=""
			switch (val) {
				case 'export':
					result = '导出'
					break;
			    case 'upload':
					result = '导入'
					break;
				default:
					result = '其它'
					break;
			}
			return result
		}
	},
	destroyed() {
	
	}
}
</script>
<style lang="scss" scoped>
#MissionCenter{
	position: absolute;
	background: #fff;
	width: 100%;
	height: 100vh;
	// z-index: 100;
	.searchNav{
        padding: 20px 0 0 20px;
		display: block; color: #959595;
		cursor: pointer;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	.el-form-item {
		margin-bottom: 15px;
	}
	::v-deep(.vxe-loading){
		z-index:  0 !important;
	}
}
</style>

